import { getQueryString } from "../../../utils/helpers";

const userProfileDictionary = {
  changeUserPassword: (userId: any) => {
    return `api/v1/user/update-user-profile`;
  },
  getProfileDetails: () => {
    return `api/v1/user/profile-details`;
  },
  deactivateUser: () => {
    return `api/v1/user/deactivate-user`;
  },
};

export default userProfileDictionary;
